<template>
    <div class="culture">

        <span>{{msg}}</span>

    </div>
</template>


<script>
import { onActivated } from 'vue';
export default {
    
    data () {
    return {
     msg: '加入我们'
    };
    },
    onActivated (){
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/JoinUs.vue